var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-container" },
    [
      _c("BjRouteTabs", {
        attrs: { "route-list": _vm.SETTING_ORGANIZATION_ROUTE_LIST },
      }),
      _c("div", { staticClass: "flex" }, [
        _c(
          "div",
          { staticClass: "group-tree" },
          [
            _c(
              "h3",
              {
                staticClass: "pointer",
                on: {
                  click: function ($event) {
                    return _vm.handleNodeClick()
                  },
                },
              },
              [_vm._v(_vm._s(_vm.group.groupName))]
            ),
            _c("el-tree", {
              ref: "tree",
              staticClass: "show-tree",
              attrs: {
                data: _vm.treeData,
                props: _vm.defaultProps,
                "expand-on-click-node": false,
              },
              on: { "node-click": _vm.handleNodeClick },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (ref) {
                    var data = ref.data
                    return [
                      _c("span", {
                        attrs: { title: data.orgName },
                        domProps: { textContent: _vm._s(data.orgName) },
                      }),
                    ]
                  },
                },
              ]),
            }),
          ],
          1
        ),
        _c(
          "div",
          { staticStyle: { width: "100%" } },
          [
            _c("BjPage", {
              ref: "BjPage",
              attrs: {
                "query-params": _vm.queryParams,
                "col-span": 6,
                "search-btn-span": 6,
                "label-width": "140px",
                "get-action": _vm.queryApi,
                serial: _vm.serial,
                selection: _vm.selection,
                "before-reset-search": _vm.reFreshLeftTree,
              },
              on: {
                handleSelectionChange: _vm.handleSelectionChange,
                showSetting: _vm.SortableTable.show,
                "header-dragend": _vm.SortableTable.handleHeaderDragend,
                "header-contextmenu": _vm.SortableTable.handleHeaderContextmenu,
                afterFetchData: _vm.afterFetchData,
              },
              scopedSlots: _vm._u([
                {
                  key: "baseForm",
                  fn: function () {
                    return [
                      _c(
                        "el-col",
                        { attrs: { span: 6 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t(
                                  "SubordinateCompanies.Header.Name"
                                ),
                                prop: "orgName",
                                "label-width": "140px",
                              },
                            },
                            [
                              _c("BjInput", {
                                attrs: {
                                  maxlength: _vm.MAX_LENGTH.DEFAULT,
                                  placeholder: _vm.$t("inputText"),
                                  clearable: "",
                                },
                                nativeOn: {
                                  keyup: function ($event) {
                                    if (
                                      !$event.type.indexOf("key") &&
                                      _vm._k(
                                        $event.keyCode,
                                        "enter",
                                        13,
                                        $event.key,
                                        "Enter"
                                      )
                                    ) {
                                      return null
                                    }
                                    return _vm.handleQuery.apply(
                                      null,
                                      arguments
                                    )
                                  },
                                },
                                model: {
                                  value: _vm.queryParams.orgName,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.queryParams, "orgName", $$v)
                                  },
                                  expression: "queryParams.orgName",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 6 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t(
                                  "SubordinateCompanies.Header.Status"
                                ),
                                prop: "status",
                              },
                            },
                            [
                              _c(
                                "el-select",
                                {
                                  staticStyle: { width: "100%" },
                                  attrs: {
                                    placeholder: _vm.$t("chooseText"),
                                    clearable: "",
                                  },
                                  model: {
                                    value: _vm.queryParams.status,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.queryParams, "status", $$v)
                                    },
                                    expression: "queryParams.status",
                                  },
                                },
                                _vm._l(
                                  _vm.STATUS_ENABLED_TRUE,
                                  function (item) {
                                    return _c("el-option", {
                                      key: item.value,
                                      attrs: {
                                        label: _vm.$t(item.label),
                                        value: item.value,
                                      },
                                    })
                                  }
                                ),
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 6 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t(
                                  "SubordinateCompanies.Header.AffiliatedCompany"
                                ),
                                prop: "pid",
                                "label-width": "140px",
                              },
                            },
                            [
                              _c("BjCompanyTreeSelect", {
                                ref: "BjCompanyTreeSelect",
                                staticClass: "full-width",
                                attrs: {
                                  placeholder: _vm.$t("chooseText"),
                                  flag: false,
                                },
                                model: {
                                  value: _vm.queryParams.pid,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.queryParams, "pid", $$v)
                                  },
                                  expression: "queryParams.pid",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ]
                  },
                  proxy: true,
                },
                {
                  key: "tableOperation",
                  fn: function (tableOperationProp) {
                    return [
                      _c(
                        "el-col",
                        [
                          _c(
                            "el-button",
                            {
                              directives: [
                                {
                                  name: "permission",
                                  rawName:
                                    "v-permission:SettingUserOrganizationCompany_Delete",
                                  arg: "SettingUserOrganizationCompany_Delete",
                                },
                              ],
                              staticClass: "delete-btn",
                              attrs: {
                                type: "primary",
                                disabled: tableOperationProp.notSelected,
                              },
                              on: { click: _vm.onDeleteSelected },
                            },
                            [_vm._v(_vm._s(_vm.$t("delText")))]
                          ),
                          _c(
                            "el-button",
                            {
                              directives: [
                                {
                                  name: "permission",
                                  rawName:
                                    "v-permission:SettingUserOrganizationCompany_Add",
                                  arg: "SettingUserOrganizationCompany_Add",
                                },
                              ],
                              staticClass: "main-btn",
                              attrs: { type: "primary" },
                              on: { click: _vm.onAdd },
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.$t(
                                    "SubordinateCompanies.Header.AddCompany"
                                  )
                                )
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                    ]
                  },
                },
                {
                  key: "tableColumn",
                  fn: function () {
                    return [
                      _vm._l(_vm.dropCols, function (col, index) {
                        return [
                          col.prop !== "bjTableAction"
                            ? _c("el-table-column", {
                                key:
                                  "col_" +
                                  index +
                                  "_" +
                                  col.prop +
                                  "_" +
                                  (col.width || "auto"),
                                attrs: {
                                  prop: col.prop,
                                  label: col.label,
                                  width: col.width || "auto",
                                  fixed: col.fixed || false,
                                  align: "center",
                                  "class-name": "item",
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function (scope) {
                                        return [
                                          false
                                            ? void 0
                                            : col.prop === "status"
                                            ? _c(
                                                "el-tag",
                                                {
                                                  attrs: {
                                                    type: scope.row.status
                                                      ? "success"
                                                      : "info",
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.$t(
                                                        _vm.$t(
                                                          _vm.STATUS_ENABLED_TRUE.bjGet(
                                                            scope.row.status
                                                          )
                                                        )
                                                      )
                                                    )
                                                  ),
                                                ]
                                              )
                                            : _c("span", [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm._f("timeFilters")(
                                                      scope.row[col.prop],
                                                      scope.row[col.prop]
                                                    )
                                                  )
                                                ),
                                              ]),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  true
                                ),
                              })
                            : _vm._e(),
                          col.prop === "bjTableAction"
                            ? _c("el-table-column", {
                                key:
                                  "col_" +
                                  index +
                                  "_" +
                                  col.prop +
                                  "_" +
                                  (col.width || "auto"),
                                attrs: {
                                  prop: col.prop,
                                  label: col.label,
                                  width: col.width || "auto",
                                  fixed: col.fixed || "right",
                                  align: "center",
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function (props) {
                                        return [
                                          _c(
                                            "el-button",
                                            {
                                              directives: [
                                                {
                                                  name: "permission",
                                                  rawName:
                                                    "v-permission:SettingUserOrganizationCompany_Edit",
                                                  arg: "SettingUserOrganizationCompany_Edit",
                                                },
                                              ],
                                              staticClass: "edit-btn",
                                              attrs: { type: "text" },
                                              on: {
                                                click: function ($event) {
                                                  return _vm.onEdit(props.row)
                                                },
                                              },
                                            },
                                            [_vm._v(_vm._s(_vm.$t("editText")))]
                                          ),
                                          props.row.status
                                            ? _c(
                                                "el-button",
                                                {
                                                  directives: [
                                                    {
                                                      name: "permission",
                                                      rawName:
                                                        "v-permission:SettingUserOrganizationCompany_Status",
                                                      arg: "SettingUserOrganizationCompany_Status",
                                                    },
                                                  ],
                                                  attrs: { type: "text" },
                                                  on: {
                                                    click: function ($event) {
                                                      return _vm.onStatus(
                                                        false,
                                                        props.row
                                                      )
                                                    },
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.$t("disableText")
                                                    )
                                                  ),
                                                ]
                                              )
                                            : _vm._e(),
                                          !props.row.status
                                            ? _c(
                                                "el-button",
                                                {
                                                  directives: [
                                                    {
                                                      name: "permission",
                                                      rawName:
                                                        "v-permission:SettingUserOrganizationCompany_Status",
                                                      arg: "SettingUserOrganizationCompany_Status",
                                                    },
                                                  ],
                                                  attrs: { type: "text" },
                                                  on: {
                                                    click: function ($event) {
                                                      return _vm.onStatus(
                                                        true,
                                                        props.row
                                                      )
                                                    },
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(_vm.$t("enableText"))
                                                  ),
                                                ]
                                              )
                                            : _vm._e(),
                                          _c(
                                            "el-button",
                                            {
                                              directives: [
                                                {
                                                  name: "permission",
                                                  rawName:
                                                    "v-permission:SettingUserOrganizationCompany_Delete",
                                                  arg: "SettingUserOrganizationCompany_Delete",
                                                },
                                              ],
                                              staticClass: "delete-btn",
                                              attrs: { type: "text" },
                                              on: {
                                                click: function ($event) {
                                                  return _vm.onDelete(props.row)
                                                },
                                              },
                                            },
                                            [_vm._v(_vm._s(_vm.$t("delText")))]
                                          ),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  true
                                ),
                              })
                            : _vm._e(),
                        ]
                      }),
                    ]
                  },
                  proxy: true,
                },
              ]),
            }),
          ],
          1
        ),
      ]),
      _c("DataForm", {
        ref: "DataForm",
        attrs: { group: _vm.group },
        on: { reFresh: _vm.reFresh, batchDeleteApi: _vm.batchDeleteApi },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }